import { useTranslation } from "@nova/use-translation"

export const WorkspaceBodyNoSearchResults = () => {
    const { t } = useTranslation()

    return (
        <div className="flex w-full flex-col gap-2 text-center select-none py-20">
            <h1 className="text-gray-0">{t("No Results Found")}</h1>
            <h5 className="text-gray-100">{t("Try adjusting your search terms.")}</h5>
        </div>
    )
}
